app.controller("purchaseCtrl", [
  "$scope",
  "$rootScope",
  "$location",
  "$http",
  "config",
  "$localStorage",
  "cart",
  "$document",
  "checkUser",
  "decrypt",
  "ngMeta",
  "$q",
  "LocalStorageFactory",
  "StripePaymentFactory",
  "ContentFactory",
  function (
    $scope,
    $rootScope,
    $location,
    $http,
    config,
    $localStorage,
    cart,
    $document,
    checkUser,
    decrypt,
    ngMeta,
    $q,
    LocalStorageFactory,
    StripePaymentFactory,
    ContentFactory
  ) {
    checkUser.checkLoginAndVerify(
      () => {},
      () => {
        $localStorage.redirect = "#/home";
        $location.path("/purchaseLogin");
      }
    );

    let microsite = LocalStorageFactory.getByKey("microsite");
    let siteConfig = microsite.microsite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    if (siteConfig.checkout) {
      $scope.stripePaymentMessage =
        siteConfig.checkout.content &&
        siteConfig.checkout.content.stripePaymentMessage;
    }

    $scope.shopCurrency = siteConfig.currency;
    $scope.cartDetails = cart.getCartQty();
    ngMeta.setTitle("Checkout");

    var bookingFee = parseFloat($scope.bookingFee);
    if (bookingFee > 0) {
      $scope.showBooking = true;
    }

    if ($scope.cartDetails.total === "0.00") {
      $scope.showBooking = false;

      if ($scope.cartDetails.qty === 1) {
        $("#payBtn").hide();
        $("#proceedButton").show();
        $("#card-element").hide();
        $("#payText").html(
          '<i class="far fa-check-circle fa-2x green-text"></i> Complementary Ticket'
        );
      }
    }

    toastr.options = {
      closeButton: true, // true/false
      debug: false, // true/false
      newestOnTop: false, // true/false
      progressBar: true, // true/false
      positionClass: "toast-top-right", // toast-top-right / toast-top-left / toast-bottom-right / toast-bottom-left
      preventDuplicates: false,
      onclick: null,
      showDuration: "300", // in milliseconds
      hideDuration: "1000", // in milliseconds
      timeOut: "5000", // in milliseconds
      extendedTimeOut: "1000", // in milliseconds
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };

    $scope.cart = LocalStorageFactory.getByKey("cart");
    if ($scope.cart !== undefined) {
      if ($scope.cart.length == 0) {
        toastr.error("Cart empty");
        localStorage.removeItem("redirect");
        $location.path("/home");
        return {};
      }
      checkTicket();
      checkCart();
    } else {
      toastr.error("Cart empty");
      localStorage.removeItem("redirect");
      $location.path("/home");
      return {};
    }

    $scope.titles = "";
    function checkTicket() {
      ContentFactory.getCustomerTickets($localStorage.shopUserID).then(
        function (tickets) {
          for (let c = 0; c < $scope.cart.length; c++) {
            for (let t = 0; t < tickets.length; t++) {
              if (tickets[t].contentID === $scope.cart[c].contentID) {
                $scope.access = true;
                $scope.titles += tickets[t].title + " ";
                break;
              }
            }
          }
        }
      );
    }

    function checkCart() {
      for (let c = 0; c < $scope.cart.length; c++) {
        let postdata = { cartItem: JSON.stringify($scope.cart[c]) };
        $http({
          method: "POST",
          url: config.fstreamAPI + "checkCart",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function success(response) {},
          function error(response) {
            if (response.status == 403) {
              return $location.path("/purchaseLogin");
            }
            toastr.warning(
              "<strong>" +
                $scope.cart[c].item +
                "</strong><br>Removed from cart<br>Invalid Price"
            );
            cart.removeFromCart($scope.cart[c].contentID, $scope);
            $scope.cartDetails = cart.getCartQty();
            $rootScope.cartValue = $scope.cartDetails.total;
            $scope.cartValue = $rootScope.cartValue;
            localStorage.removeItem("redirect");
            return $location.path("/cart");
          }
        );
      }
    }

    $scope.checkDiscount = function () {
      $scope.codeMessage = "";
      $scope.codeClass = "";

      if (!$scope.discountCode || $scope.discountCode == "") {
        $scope.codeMessage = "Please enter a discount code";
        $scope.codeClass = "text-danger";
      } else {
        let promises = [];
        for (let i = 0; i < $scope.cart.length; i++) {
          promises.push(checkDiscountCodes(i));
        }
        $q.all(promises).then(function (discountResults) {
          let successFlag = false;
          for (let i = 0; i < discountResults.length; i++) {
            if (discountResults[i]) {
              successFlag = true;
            }
          }
          if (successFlag) {
            toastr.success(
              "<strong>Success!</strong> Discount has been applied"
            );
          } else {
            toastr.error("<strong>Error!</strong> Incorrect or expired code");
          }
        });
      }
    };

    $scope.codeID = "";
    var freeSubDiscountCode = "";
    function checkDiscountCodes(index) {
      let q = $q.defer();
      var postdata = {
        contentID: $scope.cart[index].contentID,
        discountCode: $scope.discountCode,
      };

      $http({
        method: "POST",
        url: config.fstreamAPI + "checkDiscount",
        headers: {
          "Content-Type": "application/json", //x-www-form-urlencoded
          Accept: "application/json",
        },
        data: postdata,
      }).then(
        function success(response) {
          $scope.cart[index].price = response.data.data.discountPrice;
          $scope.cart[index].discountItemID =
            response.data.data.shop_discount_codeID;

          // Update cart state with discount details after successful code is applied
          LocalStorageFactory.update("cart", $scope.cart);
          $scope.cartDetails = cart.getCartQty();
          $rootScope.cartValue = $scope.cartDetails.total;
          $scope.cartValue = $scope.cartDetails.total;

          if ($scope.cartValue === "0.00") {
            $scope.showBooking = false;
          }

          $scope.codeID = response.data.data.shop_discount_codeID;

          if ($scope.cartValue === "0.00") {
            $("#payBtn").hide();
            $("#proceedButton").show();
            $("#card-element").hide();
            $("#payText").html(
              '<i class="far fa-check-circle fa-2x green-text"></i> Complementary Ticket'
            );
          }

          $("#row-" + index).css("background-color", "#00c851");
          setTimeout(function () {
            $("#row-" + index).css("background-color", "white");
          }, 3000);
          q.resolve(true);
        },
        function error() {
          q.resolve(false);
        }
      );
      return q.promise;
    }

    $scope.freeSub = function () {
      let acceptTerms = $("#accept").is(":checked");
      if (acceptTerms === true) {
        let description = `Purchase by ${$localStorage.name} ${localStorage.surname} email:${$localStorage.email} ID:${$localStorage.shopUserID}`;

        var postdata = {
          codeID: $scope.codeID,
          code: $scope.discountCode,
          total: 0,
          currency: siteConfig.currency,
          description: description,
          email: $localStorage.email,
          shopName: siteConfig.shopTitle,
          logo: siteConfig.siteLogoURL,
          purchaseThanks: siteConfig.purchaseThanks,
          detailsText: siteConfig.purchaseDetails,
          cart: $scope.cart,
          contentID: 0,
        };

        $http({
          method: "POST",
          url: config.fstreamAPI + "applyFree",
          headers: {
            "Content-Type": "application/json", //x-www-form-urlencoded
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function success() {
            resetCart();
          },
          function error() {}
        );
      }
    };

    $scope.keysSet = true;
    initStripe();

    function initStripe() {
      if (siteConfig.stripePaymentType == "connect") {
        StripePaymentFactory.stripeConnectToken().then(function (stripeToken) {
          initStripeResult(stripeToken);
        });
      } else {
        StripePaymentFactory.stripeIntentKey().then(function (stripeToken) {
          initStripeResult(stripeToken);
        });
      }
    }
    function initStripeResult(stripeToken) {
      if (stripeToken != false && stripeToken != null) {
        $("#payBtn").prop("disabled", false);
        initStripeForm(stripeToken);

        if ($rootScope.cartValue === 0) {
          resetCart();
        }
      } else {
        $scope.keysSet = false;
      }
    }

    function stripePayment(postdata, stripeValue, description, card, stripe) {
      if (siteConfig.stripePaymentType == "connect") {
        StripePaymentFactory.stripeConnectIntent(postdata).then(function (
          clientSecret
        ) {
          stripePaymentResult(
            clientSecret,
            stripeValue,
            description,
            card,
            stripe
          );
        });
      } else {
        StripePaymentFactory.stripeIntentIntent(postdata).then(function (
          clientSecret
        ) {
          stripePaymentResult(
            clientSecret,
            stripeValue,
            description,
            card,
            stripe
          );
        });
      }
    }
    function stripePaymentResult(
      clientSecret,
      stripeValue,
      description,
      card,
      stripe
    ) {
      if (clientSecret != false) {
        stripe
          .confirmCardPayment(clientSecret, {
            payment_method: {
              card: card,
              billing_details: {
                name: `${$localStorage.name} ${$localStorage.surname}`,
                email: $localStorage.email,
              },
            },
          })
          .then(function (result) {
            if (result.error) {
              $("#payBtn").prop("disabled", false);
              toastr.error(result.error.message);
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === "succeeded") {
                let postdata = StripePaymentFactory.recordPaymentPostdata(
                  result.paymentIntent.id,
                  $scope.cart
                );

                if (siteConfig.stripePaymentType == "connect") {
                  StripePaymentFactory.recordStripeConnectPayment(
                    postdata
                  ).then(function (stripePayment) {
                    if (stripePayment) {
                      resetCart();
                    }
                  });
                } else {
                  StripePaymentFactory.fulfillPaymentIntent(postdata).then(
                    function (stripePayment) {
                      if (stripePayment) {
                        resetCart();
                      }
                    }
                  );
                }
              }
            }
          });
      } else {
        $("#payBtn").prop("disabled", false);
        toastr.error("The payment could not be processed");
      }
    }

    function initStripeForm(stripeToken) {
      var stripe = Stripe(stripeToken);
      var elements = stripe.elements();

      var card = elements.create("card", {
        hidePostalCode: true,
        iconStyle: "solid",
        style: {
          base: {
            iconColor: "#8898AA",
            color: "#333333",
            lineHeight: "36px",
            fontWeight: 300,
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSize: "19px",

            "::placeholder": {
              color: "#8898AA",
            },
          },
          invalid: {
            iconColor: "#e85746",
            color: "#e85746",
          },
        },
        classes: {
          focus: "is-focused",
          empty: "is-empty",
        },
      });
      card.mount("#card-element");

      var inputs = document.querySelectorAll("input.field");
      Array.prototype.forEach.call(inputs, function (input) {
        input.addEventListener("focus", function () {
          input.classList.add("is-focused");
        });
        input.addEventListener("blur", function () {
          input.classList.remove("is-focused");
        });
        input.addEventListener("keyup", function () {
          if (input.value.length === 0) {
            input.classList.add("is-empty");
          } else {
            input.classList.remove("is-empty");
          }
        });
      });

      document.querySelector("form").addEventListener("submit", function (e) {
        if (
          $localStorage.email == null ||
          $localStorage.email == "" ||
          $localStorage.email == undefined ||
          $localStorage.shopUserID == null ||
          $localStorage.shopUserID == "" ||
          $localStorage.shopUserID == undefined
        ) {
          toastr.error(
            "Failed to process payment! Please refresh your browser and try again."
          );
          return false;
        }

        $("#payBtn").prop("disabled", true);
        e.preventDefault();

        var stripeValue = parseFloat($scope.cartDetails.total) * 100;
        var description = `Purchase by ${$localStorage.name} ${$localStorage.surname} email: ${$localStorage.email} ID: ${$localStorage.shopUserID}`;

        let postdata = {
          total: stripeValue,
          currency: siteConfig.currency,
          cart: JSON.stringify($scope.cart),
          email: $localStorage.email,
          shopUserID: $localStorage.shopUserID,
          description: description,
        };

        stripePayment(postdata, stripeValue, description, card, stripe);
      });
    }

    function resetCart() {
      LocalStorageFactory.update("cart", []);
      $scope.cart = [];
      $rootScope.cart = [];
      $rootScope.cartValue = 0;
      $rootScope.cartNumber = 0;
      $location.path("/tickets");
    }

    $document.ready(function () {}); //what does this do?
  },
]);

app.controller("transactionsCtrl", [
  "$scope",
  "$http",
  "$location",
  "$localStorage",
  "checkUser",
  "config",
  "decrypt",
  "ngMeta",
  function (
    $scope,
    $http,
    $location,
    $localStorage,
    checkUser,
    config,
    decrypt,
    ngMeta
  ) {
    checkUser.verifyLogin(
      () => {},
      () => {
        $location.path("/home");
      }
    );

    ngMeta.setTitle("Transactions");

    $scope.firstName = $localStorage.name;
    $scope.lastName = $localStorage.surname;
    $scope.email = $localStorage.email;

    $http({
      method: "POST",
      url: config.fstreamAPI + "getCustomerPurchases",
      headers: {
        "Content-Type": "application/json", //x-www-form-urlencoded
        Accept: "application/json",
      },
    }).then(
      function success(response) {
        var subs = [];
        var purchases = response.data.data.purchases;
        if (purchases.length > 0) {
          purchases.reverse();
        }

        for (var i = 0; i < purchases.length; i++) {
          var s = {};
          var contents = purchases[i].cartContents;
          var jsonContents = JSON.parse(contents);
          var desc = "";
          for (var x = 0; x < jsonContents.length; x++) {
            desc = desc + jsonContents[x].item + ", ";
          }
          desc = desc.replace(/,\s*$/, "");
          //s.description = purchases[i].description;
          s.description = desc;
          s.currency = purchases[i].currency;
          s.amount = purchases[i].amount;
          s.card = purchases[i].card;
          s.last4 = purchases[i].last4;
          s.transactionDate = purchases[i].transactionDate;
          s.receiptURL = purchases[i].receiptURL;

          subs.push(s);
        }

        //
        //$scope.subscriptions = response.data.data.purchases;
        $scope.subscriptions = subs;
        $scope.numberofsubs = $scope.subscriptions.length;
      },
      function error() {}
    );
  },
]);

app.controller("ticketsCtrl", [
  "$scope",
  "$http",
  "$location",
  "$localStorage",
  "checkUser",
  "config",
  "$interval",
  "ngMeta",
  "decrypt",
  "ContentFactory",
  "SubscriptionFactory",
  "$ngConfirm",
  function (
    $scope,
    $http,
    $location,
    $localStorage,
    checkUser,
    config,
    $interval,
    ngMeta,
    decrypt,
    ContentFactory,
    SubscriptionFactory,
    $ngConfirm
  ) {
    checkUser.verifyLogin(
      () => {},
      () => {
        $location.path("/home");
      }
    );

    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    ngMeta.setTitle("My Tickets"); //

    $scope.firstName = $localStorage.name;
    $scope.lastName = $localStorage.surname;
    $scope.email = $localStorage.email;

    $scope.customerHasSubscription = false;
    $scope.subscriptionDetails = null;

    function checkForUserSubscription() {
      SubscriptionFactory.getCustomerSubscription().then(
        function (response) {
          $scope.customerHasSubscription = true;
          SubscriptionFactory.getSubscriptionDetails(fullSite.micrositeID).then(
            function (subscriptionDetails) {
              $scope.subscriptionDetails = subscriptionDetails;
              $scope.subscriptionTicketDetails = response;
              if (response.periodEnd) {
                $scope.endDateOfSubscription = moment(response.periodEnd * 1000)
                  .local()
                  .format("dddd DD MMMM YYYY");
              }
            }
          );
        },
        function () {
          $scope.customerHasSubscription = false;
        }
      );
    }
    checkForUserSubscription();

    function manageSubscriptionModal() {
      $ngConfirm({
        title: "Manage subscription",
        content: "Would you like to cancel your subscription?",
        scope: $scope,
        buttons: {
          cancel: {
            text: "Cancel Subscription",
            btnClass: "btn btn-danger",
            action: function (scope, button) {
              button.setDisabled(true);

              SubscriptionFactory.cancelSubscription(true).then(function () {
                $ngConfirm(
                  "Your subscription has been cancelled",
                  "Manage subscription"
                );
                scope.customerHasSubscription = false;
              });
            },
          },
          close: {
            btnClass: "btn btn-primary",
            action: function (scope, button) {},
          },
        },
      });
    }

    $scope.manageSubscriptionModal = manageSubscriptionModal;
    let checkForNewTicketsTimeout = null;
    $scope.hasCheckedForNewTickets = true;

    ContentFactory.getCustomerTickets($localStorage.shopUserID).then(function (
      tickets
    ) {
      $scope.subscriptions = tickets;
      $scope.numberofsubs = tickets.length;

      $scope.hasCheckedForNewTickets = false;

      // Check for new tickets 10 seconds after page load
      checkForNewTicketsTimeout = setTimeout(function () {
        ContentFactory.getCustomerTickets($localStorage.shopUserID).then(
          function (tickets) {
            if (tickets.length !== $scope.numberofsubs) {
              $scope.subscriptions = tickets;
              $scope.numberofsubs = tickets.length;
            }
          }
        );
        $scope.hasCheckedForNewTickets = true;
      }, 10000);
    });

    var availableDays = siteConfig.vodAvailableDays;

    function calculateCountdown() {
      if ($scope.subscriptions) {
        for (let i = 0; i < $scope.subscriptions.length; i++) {
          let nowDate = new Date();

          let now = nowDate.getTime() / 1000;

          if ($scope.subscriptions[i].type == "ondemand" && availableDays > 0) {
            var availableSeconds = availableDays * 86400;
            var transDate = $scope.subscriptions[i].transactionDate;
            var expiresTS = parseInt(transDate) + parseInt(availableSeconds);

            if (expiresTS > now) {
              $scope.subscriptions[i].available = true;

              var seconds = expiresTS - Math.round(now);

              var days = Math.floor(seconds / 24 / 60 / 60);
              var hoursLeft = Math.floor(seconds - days * 86400);
              var hours = Math.floor(hoursLeft / 3600);
              var minutesLeft = Math.floor(hoursLeft - hours * 3600);
              var minutes = Math.floor(minutesLeft / 60);
              var remainingSeconds = seconds % 60;
              function pad(n) {
                return n < 10 ? "0" + n : n;
              }
              $scope.subscriptions[i].countdown =
                pad(days) +
                ":" +
                pad(hours) +
                ":" +
                pad(minutes) +
                ":" +
                pad(remainingSeconds);

              continue;
            } else {
              $scope.subscriptions[i].countdown = "Time Expired";
              $scope.subscriptions[i].available = false;
              continue;
            }
          }

          if ($scope.subscriptions[i].start == 0) {
            $scope.subscriptions[i].available = true;
            $scope.subscriptions[i].countdown = "Available";
            continue;
          }

          if (
            $scope.subscriptions[i].start < now &&
            $scope.subscriptions[i].end > now
          ) {
            $scope.subscriptions[i].countdown = "Live";
            $scope.subscriptions[i].available = true;
            continue;
          }

          if (
            $scope.subscriptions[i].start < now &&
            $scope.subscriptions[i].end < now
          ) {
            $scope.subscriptions[i].countdown = "Stream Complete";
            $scope.subscriptions[i].available = false;
            continue;
          }

          if ($scope.subscriptions[i].start > now) {
            $scope.subscriptions[i].available = true;

            var seconds = $scope.subscriptions[i].start - Math.round(now);
            var days = Math.floor(seconds / 24 / 60 / 60);
            var hoursLeft = Math.floor(seconds - days * 86400);
            var hours = Math.floor(hoursLeft / 3600);
            var minutesLeft = Math.floor(hoursLeft - hours * 3600);
            var minutes = Math.floor(minutesLeft / 60);
            var remainingSeconds = seconds % 60;
            function pad(n) {
              return n < 10 ? "0" + n : n;
            }
            $scope.subscriptions[i].countdown =
              pad(days) +
              ":" +
              pad(hours) +
              ":" +
              pad(minutes) +
              ":" +
              pad(remainingSeconds);

            continue;
          }
        }
      }
    }

    var countdownInterval = $interval(calculateCountdown, 1000);

    $scope.$on("$destroy", function () {
      // Remove timeout if page is destroyed before it fires
      if (checkForNewTicketsTimeout) {
        clearTimeout(checkForNewTicketsTimeout);
      }
      // Make sure that the interval is destroyed too
      $interval.cancel(countdownInterval);
    });
  },
]);

app.controller("purchaseNowCtrl", [
  "$routeParams",
  "$location",
  "cart",
  "$window",
  "config",
  function ($routeParams, $location, cart, $window, config) {
    let contentID = $routeParams.contentID;

    const siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    function addToCart(details, contentType) {
      if (
        details.end == undefined ||
        details.end == null ||
        details.end == 0 ||
        details.end - 300 > moment().unix()
      ) {
        let cartobj = {
          item: details.title,
          contentID: details.contentID,
          price: details.cost,
          currency: details.currency,
          discountItemID: 0,
          contentType: contentType,
        };

        cart.addToCart(cartobj);

        $location.path("/purchase");
      } else {
        toastr.error("This live stream has ended");
        $window.history.go(-1);
      }
    }

    ContentFactory.getContentType(contentID).then(function (contentType) {
      ContentFactory.getContent(contentID, contentType).then(function (
        content
      ) {
        addToCart(content, contentType);
      });
    });
  },
]);
